import React, { Suspense } from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import {
	LayoutSplashScreen,
	ContentRoute,
} from '../../../../../_metronic/layout'

import QuizSettingPage from './quizSetting/QuizSettingPage'
import { PaymentSettings } from './subscriptions/PaymentSettings'
import LeaderBoardPage from './leaderBoard/LeaderBoardPage'

const AdminPage = () => {
	const { user } = useSelector(
		(state) => ({
			user: state.auth.user,
		}),
		shallowEqual,
	)

	// Ownership comes from the Single Login v2 payload (explicit is_owner flag /
	// owner role name / derived role_level), replacing the old profile === 2.
	const { is_owner } = user

	return !is_owner ? (
		<Redirect to='/' />
	) : (
		<Suspense fallback={<LayoutSplashScreen />}>
			<Switch>
				{<Redirect exact={true} from='/admin' to='/admin/leaderBoard' />}
				{/*
				  /admin/leaderBoard is the landing route for `/admin` and is also
				  linked from HeaderMenu and from takenQuizAction's post-quiz
				  redirect - but it had no route here, so every one of those hit
				  the catch-all below and bounced to error-v2. (Dormant until an
				  account actually had userType='Admin'.) LeaderBoardPage is the
				  same component BasePage mounts at the top-level /leaderBoard.
				*/}
				<ContentRoute path='/admin/leaderBoard' component={LeaderBoardPage} />
				<ContentRoute path='/admin/quizSetting' component={QuizSettingPage} />
				<ContentRoute path='/admin/subscription' component={PaymentSettings} />
				{/* <ContentRoute path='/teacher/quizPool' component={QuizPoolPage} />
                    <ContentRoute path='/teacher/questions' component={QuestionPage} />
                    <ContentRoute path='/teacher/quiz/new' component={QuizAddPage} />
                    <ContentRoute path='/teacher/quiz/:id/edit' component={QuizEditPage} />
                    <ContentRoute path='/teacher/quiz/:id/view' component={QuizViewPage} /> */}
				<Redirect to='../error/error-v2' />
			</Switch>
		</Suspense>
	)
}

export default AdminPage
